/* eslint-disable max-len */
import { useHistory } from 'react-router-dom';
import DashboardWrap from '../../components/DashboardWrap';
import StyledButton from '../../components/StyledButton';
import { useGlobalDispatch } from '../../contexts';
import AccessDenied from './AccessDenied';
// import useToast from '../../customHooks/useToast';

import './NotAllowed.scss';

const NotAllowed = () => {
  const { clearUser } = useGlobalDispatch();
  const { push } = useHistory();
  return (
    <DashboardWrap>
      <div className="not-allowed">
        <div className="info">
          <h3>Permission Denied</h3>
          <p>You do not have permission to access this resource</p>
          <StyledButton
            name="Logout"
            onClick={() => {
              clearUser();
              push('/');
            // Logout();
            }}
            width="130px"
            height="40px"
            backgroundColor="#523B9F"
            color="#fff"
            fontSize="13px"
            borderRadius="4px"
            border="1px solid #dcd8ec"
            marginLeft="16px"
          />
        </div>
        <div className="illustr">
          <AccessDenied />
        </div>
      </div>
    </DashboardWrap>

  );
};

export default NotAllowed;
